import React from "react";
export const MetricSkeleton = () => {
    return (React.createElement("div", { className: "onvo-p-4 onvo-w-full onvo-max-w-sm onvo-animate-pulse onvo-flex onvo-flex-col" },
        React.createElement("div", { className: "onvo-h-6 onvo-w-1/2 onvo-bg-black/10 dark:onvo-bg-white/10 onvo-rounded onvo-mb-2" }),
        React.createElement("div", { className: "onvo-flex onvo-items-end onvo-space-x-2 onvo-flex-grow" },
            React.createElement("div", { className: "onvo-h-12 onvo-w-1/4 onvo-bg-black/10 dark:onvo-bg-white/10 onvo-rounded" }),
            React.createElement("div", { className: "onvo-h-6 onvo-w-1/3 onvo-bg-black/10 dark:onvo-bg-white/10 onvo-rounded" }))));
};
//# sourceMappingURL=metric.js.map